/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Cod_Summary_PendingInputs */

const vi_carrier_form_cod_summary_pending = /** @type {(inputs: Carrier_Form_Cod_Summary_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chưa có cước — chọn dịch vụ`)
};

/**

* @param {Carrier_Form_Cod_Summary_PendingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_cod_summary_pending = /** @type {((inputs?: Carrier_Form_Cod_Summary_PendingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Cod_Summary_PendingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_cod_summary_pending(inputs)
});